<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <h3 class="box-title">
        {{ $t('string.add_position') }}
      </h3>
      <div class="pull-right box-tools">
        <ButtonBack />
      </div>
    </div>
    <div class="box-body">
      <Form />
    </div>
  </div>
</template>

<script>
import Form from './Form'
import ButtonBack from '@/components/ButtonBack'

export default {
  name: 'Create',
  metaInfo () {
    return {
      title: this.$t('string.add_position'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  components: { ButtonBack, Form }
}
</script>

<style scoped></style>
